// eslint-disable-next-line import/no-cycle
import api from '@src/api';
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';

export const getOvertimeRuleSetting = (): Observable<Action> => (
	api.get('attendance-rule-sets/overtime-rule-set/setting')
);
